
const surveyJson = {
    "title": "¿Puedo ser víctima de trata de personas?",
    "completedHtmlOnCondition": [{
      "expression": "{totalScore} > (100)",
      "html": "Tu probabilidad de ser víctima de trata de personas es de <h2>{totalScore}%</h2> <br> Tus áreas de riesgo son:<br><br> <b>Enamoramiento</b>  <br> <b>Falsas ofertas laborales </b> <br> <b> VideoJuegos </b> <br> Redes Sociales <b> <br> Da Click en cada uno de los temas. Aprende cómo prevenir y blindar tu vida y la de los que más amas!"
    //}, {
    //  "expression": "{totalScore} <= (40)",
    //  "html": "You got {totalScore} out of {maxScore} points. Come on now, step up!"
    //}, {
    //  "expression": "({maxScore} / 3 * 2) < {totalScore} <= ({maxScore} / 3)",
    //  "html": "You got {totalScore} out of {maxScore} points. Well done!"
    }],
    //"logo": "https://findelaesclavitud.org/wp-content/uploads/2022/08/favicon-256x256-1.png",
    "logo": "https://findelaesclavitud.org/wp-content/uploads/2022/08/favicon-256x256-2.png",
    "logoWidth": 130,
    "logoHeight": 130,
    "logoPosition": "left",
    "description": "Gracias por darte el tiempo de contestar esta encuesta, la cual te permitirá saber qué tan susceptibles eres de ser víctima de trata de personas. Te recomendamos ser lo más honestx posible.",
    
    "pages": [
      {
       "name": "demograficos",
       "elements": [
        {
          "type": "image",
          "name": "falconImage",
          "imageLink": 'https://i.imgur.com/XEOvIBn.jpg',
        },{
         "type": "radiogroup",
         "name": "edad",
         "title": "Edad",
         "isRequired": true,
         "choices": [
          { "value": "<10", "text": "Menor de 10 años",'score': 0.8},
          { "value": "10-14", "text": "10-14 años",'score': 1.3},
          { "value": "15-25", "text": "15-25 años",'score': 1.5},
          { "value": "26-35","text": "26-35 años",'score': 1.0},
          { "value": ">35", "text": "Más de 35 años",'score': 0.5}
         ]
        },
        {
          "type": "image",
          "name": "Lugar de residencia",
          "imageLink": 'https://i.imgur.com/RZ0eBDg.jpg',
        },
        {
         "type": "dropdown",
         "name": "estado",
         "title": "Lugar de Residencia",
         "isRequired": true,
         "choices": [   
          {"value":"Estado de México","text":"Estado de México","score":2.5},
          {"value":"Ciudad de México","text":"Ciudad de México","score":2.5},
          {"value":"Quintana roo","text":"Quintana Roo","score":2.5},
          {"value":"Baja California","text":"Baja California","score":2.5},
          {"value":"Puebla","text":"Puebla","score":2.5},
          {"value":"Chiapas","text":"Chiapas","score":2.5},
          {"value":"Cohahuila","text":"Cohahuila","score":2.5},
          {"value":"Chihuahua","text":"Chihuahua","score":2.5},
          {"value":"Nuevo Léon","text":"Nuevo Léon","score":2.5},
          {"value":"Jalisco","text":"Jalisco","score":2.5},
          {"value":"Tlaxcala","text":"Tlaxcala","score":2.5},

          {"value":"Zacatecas","text":"Zacatecas","score":1.5},
          {"value":"Tabasco","text":"Tabasco","score":1.5},
          {"value":"Veracruz","text":"Veracruz","score":1.5},
          {"value":"Oaxaca","text":"Oaxaca","score":1.5},
          {"value":"Guerrero","text":"Guerrero","score":1.5},
          {"value":"Michoacán","text":"Michoacán","score":1.5},
          {"value":"Hidalgo","text":"Hidalgo","score":1.5},
          {"value":"Querétaro","text":"Querétaro","score":1.5},
          {"value":"San Luis Potosí","text":"San Luis Potosí","score":1.5},
          {"value":"Sinaloa","text":"Sinaloa","score":1.5},
          {"value":"Nayarit","text":"Nayarit","score":1.5},
          {"value":"Tamaulipas","text":"Tamaulipas","score":1.5},

          {"value":"Aguascalientes","text":"Aguascalientes","score":1},
          {"value":"Guanajuato","text":"Guanajuato","score":1},
          {"value":"Yucatán","text":"Yucatán","score":1},
          {"value":"Baja California Sur","text":"Baja California Sur","score":1},
          {"value":"Campeche","text":"Campeche","score":1},
          {"value":"Nayarit","text":"Nayarit","score":1},
          {"value":"Sonora","text":"Sonora","score":1},
          {"value":"Durango","text":"Durango","score":1},
          {"value":"Colima","text":"Colima","score":1}
         ],
        },
        {
          "type": "image",
          "name": "Lugar de residencia",
          "imageLink": 'https://i.imgur.com/DU9SdpA.jpg',
        },
        {
          "type": "radiogroup",
          "name": "genero",
          "title": "Género",
          "isRequired": true,
          "choices": [
           { "value": "hombre", "text": "Hombre",'score': 2.0},
           { "value": "mujer", "text": "Mujer",'score': 2.5},
           { "value": "Otro", "text": "Otro",'score': 0.25},
          ]
         },
       ],
       //"title": "demograficos"
      },{
        "name": "acercamiento",
        "elements": [
          {
            "type": "image",
            "name": "NecesidadEconomica",
            "imageLink": 'https://i.imgur.com/3MvcGru.jpg',
          },
          {
            "type": "radiogroup",
            "name": "nececidadEconomica",
            "isRequired": true,
            "imageLink": 'https://i.imgur.com/3MvcGru.jpg',
            "title": "¿Tienes la necesidad de aportar económicamente en tu hogar o familia?",
            "choices": [
             { "value": "si", "text": "Sí",'score': 1.75},
             { "value": "no", "text": "No",'score': 0.75},
            ]
           },
           {
            "type": "image",
            "name": "NecesidadEconomica",
            "imageLink": 'https://i.imgur.com/RBw1MdP.jpg',
          },
           {
            "type": "radiogroup",
            "name": "conocesDesaparecido",
            "imageLink": 'https://i.imgur.com/RBw1MdP.jpg',
            "title": "¿Conoces a una persona cercana o conocida que haya desaparecido?",
            "choices": [
             { "value": "si", "text": "Sí",'score': 2},
             { "value": "no", "text": "No",'score': 0.5},
            ]
           },
           {
            "type": "image",
            "name": "creesQueTePuedePasar",
            "imageLink": 'https://i.imgur.com/xWrcR0W.jpg',
          },
           {
            "type": "radiogroup",
            "name": "creesQueTePuedePasar",
            "imageLink": 'https://i.imgur.com/xWrcR0W.jpg',
            "title": "¿Crees que te pueda pasar a ti?",
            "choices": [
             { "value": "si", "text": "Sí",'score': 0.25},
             { "value": "no", "text": "No",'score': 2.5},
            ]
           },
           {
            "type": "image",
            "name": "SabesQueesLaTrata",
            "imageLink": 'https://i.imgur.com/XNY6JDZ.jpg',
          },
           {
            "type": "radiogroup",
            "name": "sabesqueEsLaTrata",
            "title": "¿Sabes lo que es la trata de personas?",
            "imageLink": 'https://i.imgur.com/XNY6JDZ.jpg',
            "choices": [
             { "value": "si", "text": "Sí",'score': 0.25},
             { "value": "no", "text": "No",'score': 2.5},
            ]
           },
        ],

      },{
        "title": "Falsas ofertas laborales",
        "name": "falsasOfertas",
        "visibleIf": "{nececidadEconomica} = 'si' and ( {edad} != '<10' or {edad} != '10-14' )",
        "description":"En esta sección encontrarás preguntas relacionadas con el ámbito laboral. Te pedimos que contestes de manera honesta.",
        "elements": [
          {"type": "image", "name": "Trabajo1", "imageLink": 'https://i.imgur.com/4viChMt.jpg'},
          {
            "type": "checkbox",
            "name": "aceptariasTrabajoOtroEstado",
            "title": "¿Aceptarías un trabajo en otro estado que no sea en donde vives?",
            
            "choices": [
              {"value":"Sí, siempre que cubran mis gastos ","text":"Sí, siempre que cubran mis gastos" ,"score":3.5,'threat':'TR'},
              {"value":"Sí, siempre que el sueldo sea atractivo ","text":"Sí, siempre que el sueldo sea atractivo" ,"score":3.5,'threat':'TR'},
              {"value":"Sí, mientras que no me pidan experiencia laboral","text":"Sí, mientras que no me pidan experiencia laboral","score":3.5,'threat':'TR'},
              {"value":"Sí, si es fuera del país ","text":"Sí, si es fuera del país" ,"score":1,'threat':'TR'},
              {"value":"No, si me piden inglés ","text":"No, si me piden inglés" ,"score":1},
              {"value":"No, si no es un buen sueldo ","text":"No, si no es un buen sueldo" ,"score":0.5},
              {"value":"No, si sospecho que es mentira","text":"No, si sospecho que es mentira","score":0.5},
              {"value":"No, si es lejos de mi familia ","text":"No, si es lejos de mi familia" ,"score":0.5},
            ]
           },
           {"type": "image", "name": "Trabajo2", "imageLink": 'https://i.imgur.com/RQMgXYu.jpg'},
           {
            "type": "checkbox",
            "name": "utilizasHerramientasCorroborarOfertaLaboral",
            "title": "¿Utilizas alguna de las siguientes herramientas para corroborar la oferta laboral?",
            "choices": [         
              {"value":"Recomendación","text":"Recomendación","score":3.5,'threat':'TR'},
              {"value":"Internet","text":"Internet","score":1},
              {"value":"LinkedIn ","text":"LinkedIn" ,"score":0.5},
              {"value":"SAT (búsqueda de RFC u otros datos oficiales)","text":"SAT (búsqueda de RFC u otros datos oficiales)","score":0.5},
              {"value":"No verifico","text":"No verifico nada" ,"score":3.5,'threat':'TR'}
            ]
           },
           {"type": "image", "name": "Trabajo3", "imageLink": 'https://i.imgur.com/zLeFE2V.jpg'},
           {
            "type": "checkbox",
            "name": "tomasPrecaucionesEntrevistaTrabajo",
            "title": "¿Tomas medidas de precaución al ir a una entrevista de trabajo?",
            "choices": [
              {"value":"Investigación de la empresa","text":"Investigación de la empresa","score":0.25},
              {"value":"Revisar ubicación antes de aceptar ir","text":"Revisar ubicación antes de aceptar ir","score":0.25},
              {"value":"Ir acompañado/a a la entrevista o el primer día de trabajo","text":"Ir acompañado/a a la entrevista o el primer día de trabajo","score":0.25},
              {"value":"Mandar ubicación a alguien de confianza","text":"Mandar ubicación a alguien de confianza","score":0.25},
              {"value":"Ninguna de las anteriores","text":"Ninguna de las anteriores","score":1,'threat':'TR'}
            ]
           },
        ],
        
      },{
        "title": "Enamoramiento",
        "name": "enamoramiento",
        "description": "En esta sección encontrarás preguntas relacionadas con la formación de vínculos amorosos. Te pedimos contestes las siguientes preguntas de forma honesta.",
        "elements": [
          
          {"type": "image", "name": "Enamoramiento1", "imageLink": 'https://i.imgur.com/MkYGrk3.jpg'},
          {
            "type": "radiogroup",
            "name": "utilizadoPlataformaConocerPersonas",
            "title": "¿Has utilizado alguna plataforma para conectar con personas nuevas?",
            "choices": [
              {"value":"si","text":"Sí ","score":4.5},
              {"value":"no","text":"No","score":0.5}
            ]
          },
          {"type": "image", "name": "Enamoramiento2", "imageLink": 'https://i.imgur.com/6UUU356.jpg',"visibleIf": "{utilizadoPlataformaConocerPersonas} = 'si'"},
          {
            "type": "radiogroup",
            "name": "dispuesxConocerPersonaNueva",
            "visibleIf": "{utilizadoPlataformaConocerPersonas} = 'si'",
            "title": "¿Estarías dispuestx a conocer personalmente a un contacto nuevo de tus redes sociales, porque te atrajo la persona físicamente y/o por su forma de ser?",
            "choices": [
              {"value":"si","text":"Sí","score":4.5,'threat':'EN'},
              {"value":"no","text":"No ","score":0.5}
            ]
          },
          {"type": "image", "name": "Enamoramiento3", "imageLink": 'https://i.imgur.com/ePQes1w.jpg',"visibleIf": "{utilizadoPlataformaConocerPersonas} = 'si'"},
          {
            "type": "checkbox",
            "name": "tomariasPrecaucionesCita",
            "visibleIf": "{utilizadoPlataformaConocerPersonas} = 'si'",
            "title": "Si aceptarás la cita de una persona que conociste por redes sociales ¿tomarías alguna precaución antes o durante la cita?",
            "choices": [
              {"value":"Compartir mi ubicación con alguien de confianza ","text":"Compartir mi ubicación con alguien de confianza ","score":0.5},
              {"value":"Hacerle saber a una persona de confianza de la cita","text":"Hacerle saber a una persona de confianza de la cita","score":0.5},
              {"value":"Ir acompañado/a al lugar de la cita ","text":"Ir acompañado/a al lugar de la cita ","score":0.5},
              {"value":"Verificar y compartir el perfil de la persona con la que tengo la cita","text":"Verificar y compartir el perfil de la persona con la que tengo la cita","score":0.5},
              {"value":"Otro","text":"Otro","score":0.5},
              {"value":"Ninguna de las anteriores ","text":"Ninguna de las anteriores ","score":4.5,'threat':'EN'}
            ]
          },
          {"type": "image", "name": "Enamoramiento1", "imageLink": 'https://i.imgur.com/ZtGyQmN.jpg',"visibleIf": "{utilizadoPlataformaConocerPersonas} = 'si'"},
           {
            "type": "radiogroup",
            "name": "vivirJuntxsPocoTiempo",
            "visibleIf": "{utilizadoPlataformaConocerPersonas} = 'si'",
            "title": "¿Qué tan de acuerdo estás en que las personas decidan irse a vivir juntas al poco tiempo de conocerse en redes sociales?",
            "choices": [
              {"value":"Muy de acuerdo","text":"Muy de acuerdo","score":4,'threat':'EN'},
              {"value":"De acuerdo ","text":"De acuerdo ","score":4,'threat':'EN'},
              {"value":"Medianamente de acuerdo ","text":"Medianamente de acuerdo ","score":0.75,'threat':'EN'},
              {"value":"Poco de acuerdo","text":"Poco de acuerdo","score":0.25},
              {"value":"Nada de acuerdo","text":"Nada de acuerdo","score":0.25},
            ]
           },
        ],
        
      },
      {
        "title": "Videojuegos",
        "name": "videojuegos",
        "description":"En esta sección encontrarás preguntas relacionadas con el uso de videojuegos o plataformas digitales de juego. Te pedimos que contestes de forma honesta.",
        "elements": [
          {"type": "image", "name": "Videjuego1", "imageLink": 'https://i.imgur.com/mzyOYAI.jpg'},
          {
            "type": "radiogroup",
            "name": "JuegasVideojuegosRegularmente",
            "title": "¿Juegas videojuegos con regularidad o utilizas plataformas digitales de juego?",
            "choices": [
              {"value":"si","text":"Sí","score":0},
              {"value":"no","text":"No ","score":0}
            ]
           },
           {"type": "image", "name": "Videjuego2", "imageLink": 'https://i.imgur.com/FaQQatr.jpg',"visibleIf": "{JuegasVideojuegosRegularmente} = 'si'"},
           {
            "type": "checkbox",
            "name": "horarioVidejuegos",
            "visibleIf": "{JuegasVideojuegosRegularmente} = 'si'",
            "title": "¿En qué horario acostumbras jugar regularmente?",
            "choices": [
              {"value":"Por la tarde (De 12pm a 6pm)","text":"Por la tarde (De 12pm a 6pm)","score":0.4},
              {"value":"Por la noche (de 7pm a 12am)","text":"Por la noche (de 7pm a 12am)","score":0.8},
              {"value":"Por la madrugada (de 1am a 5am) ","text":"Por la madrugada (de 1am a 5am) ","score":2.8,'threat':'VJ'},
            ]
           },
           {"type": "image", "name": "Videjuego3", "imageLink": 'https://i.imgur.com/yJX1q66.jpg',"visibleIf": "{JuegasVideojuegosRegularmente} = 'si'",},
           {
            "type": "radiogroup",
            "name": "entablarAmistadVideojuegos",
            "visibleIf": "{JuegasVideojuegosRegularmente} = 'si'",
            "title": "¿Has entablado una amistad con alguien más por medio de algún videojuego?",
            "choices": [
              {"value":"si","text":"Sí","score":3.6,'threat':'VJ'},
              {"value":"no","text":"No ","score":0.4}
            ]
           },
           {"type": "image", "name": "Videjuego4", "imageLink": 'https://i.imgur.com/X1YliHy.jpg',"visibleIf": "{JuegasVideojuegosRegularmente} = 'si'",},
           {
            "type": "radiogroup",
            "name": "aceptaroasAmigoPaguePorUpgradesVideojuegos",
            "visibleIf": "{JuegasVideojuegosRegularmente} = 'si'",
            "title": "¿Aceptarías que alguno de tus amigos dentro de los videojuegos pague mejoras o upgrades por ti en tus videojuegos?",
            "choices": [
              {"value":"si","text":"Sí","score":3.6,'threat':'VJ'},
              {"value":"no","text":"No ","score":0.4}
            ]
           },
           {"type": "image", "name": "Videjuego5", "imageLink": 'https://i.imgur.com/gw0PDza.jpg',"visibleIf": "{JuegasVideojuegosRegularmente} = 'si'",},
           {
            "type": "radiogroup",
            "name": "dispuestoConocerPersonaVideojuegos",
            "visibleIf": "{JuegasVideojuegosRegularmente} = 'si'",
            "title": "¿Qué tan dispuesto estás a conocer en persona a otro jugador con el que constantemente interactuas si te lo pidiera?",
            "choices": [
              {"value":"Muy dispuesto/a","text":"Muy dispuesto/a","score":2.8,'threat':'VJ'},
              {"value":"Dispuesto/a","text":"Dispuesto/a","score":2.8,'threat':'VJ'},
              {"value":"Algo dispuesto/a","text":"Algo dispuesto/a","score":0.8,'threat':'VJ'},
              {"value":"Poco dispuesto/a","text":"Poco dispuesto/a","score":0.4},
              {"value":"Nada dispuesto/a","text":"Nada dispuesto/a","score":0.4},
            ]
           },
           {"type": "image", "name": "Videjuego6", "imageLink": 'https://i.imgur.com/R55Yolf.jpg',"visibleIf": "{JuegasVideojuegosRegularmente} = 'si'",},
           {
            "type": "checkbox",
            "name": "videojuegosJugados",
            "visibleIf": "{JuegasVideojuegosRegularmente} = 'si'",
            "title": "¿Cuál de estos videojuegos has jugado?",
            "choices": [
              {"value":"Free Fire ","text":"Free Fire ","score":0},
              {"value":"Fornite ","text":"Fornite","score":0},
              {"value":"Roblox","text":"Roblox","score":0},
              //{"value":"Gears of War ","text":"Gears of War ","score":0},
              {"value":"Minecraft","text":"Minecraft","score":0},
              {"value":"Call of Duty","text":"Call of Duty","score":0},
              {"value":"Counter Strike","text":"Counter Strike","score":0},
              //{"value":"Battlegrounds ","text":"Battlegrounds ","score":0},
              {"value":"Grand Theft Auto ","text":"Grand Theft Auto ","score":0},
              {"value":"Ninguno de estos","text":"Ninguno de estos","score":0},
            ]
           },
           
        ],
        
      },
      {
        "title": "Redes Sociales",
        "name": "redesSociales",
        "visibleIf": "{edad} == '15-25' or {edad} == '26-35' or {edad} == '>35'",

        "description":"En esta sección encontrarás preguntas relacionadas con el manejo de redes sociales. Te pedimos que contestes de forma honesta.",
        "elements": [
          {"type": "image", "name": "Redes1", "imageLink": 'https://i.imgur.com/eqFJFeC.jpg'},
          {
            "type": "checkbox",
            "name": "redesSocialesParticipas",
            "title": "¿En qué redes sociales o plataformas participas?",
            "choices": [
              {"value":"Instagram","text":"Instagram","score":0},
              {"value":"Facebook","text":"Facebook","score":0},
              {"value":"TikTok","text":"TikTok","score":0},
              {"value":"BeReal","text":"BeReal","score":0},
              {"value":"Twitter","text":"X (Twitter)","score":0},
              {"value":"Discord","text":"Discord","score":0},
              {"value":"Snapchat","text":"Snapchat","score":0},
              {"value":"Tinder","text":"Tinder","score":0},
              {"value":"Onlyfans","text":"Onlyfans","score":0},
              {"value":"Whatsapp","text":"Whatsapp","score":0},
              {"value":"Otros","text":"Otros","score":0},
            ]
           },
           {"type": "image", "name": "Redes2", "imageLink": 'https://i.imgur.com/OBfCYNN.jpg'},
           {
            "type": "radiogroup",
            "name": "privacidadRedesSociales",
            "title": "¿Tus redes sociales en que nivel de privacidad suelen estar?",
            "choices": [
              {"value":"Público ","text":"Público ","score":4.5,'threat':'RS'},
              {"value":"Ni idea","text":"Ni idea","score":4.5},
              {"value":"Privado","text":"Privado","score":0.5},
            ]
           },
           {"type": "image", "name": "Redes3", "imageLink": 'https://i.imgur.com/jbwRbWd.jpg'},

           {
            "type": "radiogroup",
            "name": "importanciaTenerSeguidores",
            "title": "¿Qué tan importante es para ti tener muchos seguidores?",
            "choices": [
              {"value":"Muy importante","text":"Muy importante","score":4.5,'threat':'RS'},
              {"value":"Importante","text":"Importante","score":4.5,'threat':'RS'},
              {"value":"Poco importante","text":"Poco importante","score":0.5},
              {"value":"Nada importante","text":"Nada importante","score":0.5},
            ]
           },
           {"type": "image", "name": "Redes4", "imageLink": 'https://i.imgur.com/K8ZxoHH.jpg'},

           {
            "type": "checkbox",
            "name": "terminosConocesRedesSociales",
            "title": "Selecciona sólo los términos que conozcas de la siguiente lista",
            "choices": [
              {"value":"Grooming","text":"Grooming","score":0.5},
              {"value":"Sexting","text":"Sexting","score":0.5},
              {"value":"Catfish","text":"Catfish","score":0.5},
              {"value":"Ninguna","text":"Ninguna","score":4.5,'threat':'RS'},
            ]
           },
           {"type": "image", "name": "Redes5", "imageLink": 'https://i.imgur.com/kUcEHMn.jpg'},
           {
            "type": "radiogroup",
            "name": "solicitudFotosVideosIntimos",
            "title": "¿Has recibido solicitud de enviar/generar fotos o videos íntimos por tus contactos conocidos y/o desconocidos?",
            "choices": [
              {"value":"si","text":"Sí","score":4.5,'threat':'RS'},
              {"value":"no","text":"No","score":0.5}
            ]
           }

        ],
        
      }
     ]
  };
  export { surveyJson };